import { setupFareAdapterElementForm } from '../../lib/form_helpers';

const AdministrationFareAdapterConfigurationElements = {
  init() {
    setupFareAdapterElementForm();
  }
};

export default AdministrationFareAdapterConfigurationElements;
